import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const employeeDutyLocaleModule: LocaleModule = {
  name: "employeeDuty",
  messages: { en: en, it: it },
};
